import apiClient from './axiosInstance';

export interface CompanyInfo {
  companyName: string;
  companyNameAr: string;
  address: string;
  phone: string;
  email: string;
  website?: string;
  logoPath: string | null;
  logoBase64?: string | null; // ✅ Base64 for Excel/PDF exports
}

class CompanyInfoService {
  async getCompanyInfo(): Promise<CompanyInfo> {
    try {
      const response = await apiClient.get('/CompanySettings');
      const data = response.data;
      
      return {
        companyName: data.companyName || 'Company Name',
        companyNameAr: data.companyNameAr || 'اسم الشركة',
        address: data.address || '',
        phone: data.phone || '',
        email: data.email || '',
        website: data.website || '',
        logoPath: data.logoPath || null,
        logoBase64: data.logoBase64 || null // ✅ Backend sends base64
      };
    } catch (error) {
      console.error('Error fetching company info:', error);
      // Return default values if API fails
      return {
        companyName: 'Company Name',
        companyNameAr: 'اسم الشركة',
        address: '',
        phone: '',
        email: '',
        website: '',
        logoPath: null,
        logoBase64: null
      };
    }
  }
}

export const companyInfoService = new CompanyInfoService();